import { render, staticRenderFns } from "./printA4.vue?vue&type=template&id=9b5f35f0&scoped=true&"
import script from "./printA4.vue?vue&type=script&lang=js&"
export * from "./printA4.vue?vue&type=script&lang=js&"
import style0 from "./printA4.vue?vue&type=style&index=0&id=9b5f35f0&lang=sass&scoped=true&"
import style1 from "./printA4.vue?vue&type=style&index=1&id=9b5f35f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5f35f0",
  null
  
)

export default component.exports